import React from "react";
import styles from "./Select.module.css";

function Select(props) {
  const {
    id,
    label,
    placeholder,
    disabled = false,
    style = {},
    value,
    setValue,
    list,
    validate,
    disabledLabel,
  } = props;

  return (
    <div className={styles.container}>
      {label && !disabledLabel && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}

      <select
        id={id}
        style={style}
        disabled={disabled}
        className={`${styles.select} ${validate && !value ? styles.error : ""} ${disabled ? styles.disabled : ""} ${value ? "" : styles.gray}`}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        aria-label={!label ? placeholder : undefined}
      >
        {props.default ?? (
          <option value="" disabled={validate}>
            {placeholder}
          </option>
        )}
        {list?.map((item, idx) => {
          return (
            <option key={idx} style={{ color: "black" }} value={item["key"]}>
              {item["value"]}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default Select;
